const STORAGE_KEY = "camping_guest_shop_session";

export type ShopGuest = {
  id: string;
  first_name: string;
  last_name: string;
  email: string | null;
};

export type ShopStay = {
  booking_id: string;
  booking_number: string;
  pitch_code: string | null;
  arrival_date: string;
  departure_date: string;
};

export type ShopSession = {
  expires_at: string;
  guest: ShopGuest;
  stay: ShopStay;
};

export function loadShopSession(): ShopSession | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as ShopSession;
    if (!parsed.guest || !parsed.stay) return null;
    if (parsed.expires_at && new Date(parsed.expires_at).getTime() < Date.now()) {
      clearShopSession();
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function saveShopSession(session: ShopSession): void {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(session));
}

export function clearShopSession(): void {
  sessionStorage.removeItem(STORAGE_KEY);
}

export function isShopSessionExpired(session: ShopSession | null): boolean {
  if (!session?.expires_at) return true;
  return new Date(session.expires_at).getTime() < Date.now();
}
